module.exports = __webpack_public_path__ + "static/media/38-6.63f85e8d.mp3";